import xliff2js from './xliff2js.js';
import js2xliff from './js2xliff.js';

export { xliff2js, js2xliff };
export default {
  xliff2js,
  js2xliff,
};
